<template>
  <div class="order-details">
    <!-- 给header上与data上加on为退款订单-->
    <div
      class="header bg-color-red acea-row row-middle"
      :class="refundOrder ? 'on' : ''"
    >
      <div class="pictrue" v-if="!refundOrder">
        <img :src="orderInfo.status_pic" />
      </div>
      <div class="data" :class="refundOrder ? 'on' : ''">
        <div class="state">{{ orderInfo._status._msg }}</div>
        <div>
          {{ orderInfo.add_time_y
          }}<span class="time">{{ orderInfo.add_time_h }}</span>
        </div>
      </div>
    </div>
    <template v-if="!refundOrder">
      <div class="nav">
        <div class="navCon acea-row row-between-wrapper">
          <div :class="{ on: status.type === 5 }">待審核</div>
          <div :class="{ on: status.type === 0 || status.type === 9 }">
            待付款
          </div>
          <div
            :class="{ on: status.type === 1 }"
            v-if="orderInfo.shipping_type === 2"
          >
            待核銷
          </div>
          <div :class="{ on: status.type === 1 }" v-else>待發貨</div>
          <div
            :class="{ on: status.type === 2 }"
            v-if="orderInfo.shipping_type === 1"
          >
            待收貨
          </div>
          <div :class="{ on: status.type === 3 }">待評價</div>
          <div :class="{ on: status.type === 4 }">已完成</div>
        </div>
        <div class="progress acea-row row-between-wrapper">
          <div
            class="iconfont"
            :class="[
              status.type === 5 ? 'icon-webicon318' : 'icon-yuandianxiao',
              status.type >= 0 ? 'font-color-red' : ''
            ]"
          ></div>
          <div
            class="line"
            :class="{ 'bg-color-red': status.type > 0 && status.type != 9 }"
          ></div>
          <div
            class="iconfont"
            :class="[
              status.type === 0 || status.type === 9
                ? 'icon-webicon318'
                : 'icon-yuandianxiao',
              status.type >= 0 && status.type != 6 && status.type != 9
                ? 'font-color-red'
                : ''
            ]"
          ></div>
          <div
            class="line"
            :class="{
              'bg-color-red':
                status.type > 1 && status.type != 6 && status.type != 9
            }"
            v-if="orderInfo.shipping_type === 1"
          ></div>
          <div
            class="iconfont"
            :class="[
              status.type === 1 ? 'icon-webicon318' : 'icon-yuandianxiao',
              status.type >= 1 && status.type != 6 && status.type != 9
                ? 'font-color-red'
                : ''
            ]"
            v-if="orderInfo.shipping_type === 1"
          ></div>
          <div
            class="line"
            :class="{
              'bg-color-red':
                status.type >= 2 && status.type != 6 && status.type != 9
            }"
          ></div>
          <div
            class="iconfont"
            :class="[
              status.type === 2 ? 'icon-webicon318' : 'icon-yuandianxiao',
              status.type >= 2 && status.type != 6 && status.type != 9
                ? 'font-color-red'
                : ''
            ]"
          ></div>
          <div
            class="line"
            :class="{
              'bg-color-red':
                status.type >= 3 && status.type != 6 && status.type != 9
            }"
          ></div>
          <div
            class="iconfont"
            :class="[
              status.type == 3 ? 'icon-webicon318' : 'icon-yuandianxiao',
              status.type >= 3 && status.type != 6 && status.type != 9
                ? 'font-color-red'
                : ''
            ]"
          ></div>
          <div
            class="line"
            :class="{
              'bg-color-red':
                status.type >= 4 && status.type != 6 && status.type != 9
            }"
          ></div>
          <div
            class="iconfont"
            :class="[
              status.type == 4 ? 'icon-webicon318' : 'icon-yuandianxiao',
              status.type >= 4 && status.type != 6 && status.type != 9
                ? 'font-color-red'
                : ''
            ]"
          ></div>
        </div>
      </div>
      <div
        class="writeOff"
        v-if="orderInfo.shipping_type === 2 && orderInfo.paid === 1"
      >
        <div class="title">核銷信息</div>
        <div class="grayBg">
          <div class="pictrue"><img :src="orderInfo.code" /></div>
        </div>
        <div class="gear"><img src="@assets/moblie/images/writeOff.jpg" /></div>
        <div class="num">{{ orderInfo._verify_code }}</div>
        <div class="rules">
          <div class="item">
            <div class="rulesTitle acea-row row-middle">
              <span class="iconfont icon-shijian"></span>核銷時間
            </div>
            <div class="info">
              每日：<span class="time">{{ system_store.day_time }}</span>
            </div>
          </div>
          <div class="item">
            <div class="rulesTitle acea-row row-middle">
              <span class="iconfont icon-shuoming1"></span>使用說明
            </div>
            <div class="info">可將二維碼出示給店員掃描或提供數字核銷碼</div>
          </div>
        </div>
      </div>
      <div
        class="map acea-row row-between-wrapper"
        v-if="orderInfo.shipping_type === 2 && orderInfo.paid === 1"
      >
        <div>自提地址信息</div>
        <div
          class="place cart-color acea-row row-center-wrapper"
          @click="showChang"
        >
          <span class="iconfont icon-weizhi"></span>查看位置
        </div>
      </div>
      <div class="address" v-if="orderInfo.shipping_type === 1">
        <div class="name">
          {{ orderInfo.real_name
          }}<span class="phone">{{ orderInfo.user_phone }}</span>
        </div>
        <div>{{ orderInfo.user_address }}</div>
      </div>
      <div class="address" v-else>
        <div class="name">
          {{ system_store.name
          }}<span class="phone">{{ system_store.phone }}</span>
          <a
            class="iconfont icon-tonghua font-color-red"
            :href="'tel:' + system_store.phone"
          ></a>
        </div>
        <div>{{ system_store._detailed_address }}</div>
      </div>
      <div class="line" v-if="orderInfo.shipping_type === 1">
        <img src="@assets/moblie/images/line.jpg" />
      </div>
    </template>
    <OrderGoods
      :evaluate="status.type || 0"
      :cartInfo="orderInfo.cartInfo || []"
    ></OrderGoods>
    <!--
    <template v-if="userInfo.certification_type == 2">
      <div
        class="wrapper"
        v-for="(item, index) in productPriceList"
        :key="index"
      >
        <div class="qoutePrice" v-if="index == 0">药品报价单</div>
        <div class="item acea-row row-between">
          <div>药品名称：</div>
          <div class="conter sheWidth font-color-red line1">
            {{ item.productName }}
          </div>
        </div>
        <div class="item acea-row row-between">
          <div>药品单价：</div>
          <div class="conter sheWidth">{{ item.chinseSimplePrice }}元</div>
        </div>
        <div class="item acea-row row-between">
          <div>数量：</div>
          <div class="conter sheWidth">{{ item.num }}</div>
        </div>
        <div class="item acea-row row-between">
          <div>药品总价：</div>
          <div class="conter sheWidth">{{ item.sumPrice }}元</div>
        </div>
        <div class="item acea-row row-between">
          <div>付款方式：</div>
          <div class="conter acea-row row-middle row-right">
            {{ item.paymentType == 1 ? "不支持境外付款" : "支持境外付款" }}
          </div>
        </div>
        <div class="item acea-row row-between" v-if="item.paymentType == 1">
          <div>开票方式：</div>
          <div class="conter acea-row row-middle row-right">
            <block v-if="item.TicketType == 0">货值开13% 其他开6%</block>
            <block v-else-if="item.TicketType == 1">服务费发票税点6%</block>
            <block v-else>增值税专票税点13%</block>
          </div>
        </div>
        <div class="item acea-row row-between" v-if="item.COO">
          <div>原产地证明COO：</div>
          <div class="conter sheWidth">{{ item.COO }}元</div>
        </div>
        <div class="item acea-row row-between" v-if="item.transparent">
          <div>运输费用：</div>
          <div class="conter">{{ item.transparent }}元</div>
        </div>
        <div class="item acea-row row-between" v-if="item.clearance == 1">
          <div>代理清关费：</div>
          <div class="conter">{{ item.clearancefinally }}元</div>
        </div>
        <div class="item acea-row row-between">
          <div>报关口岸：</div>
          <div class="conter">{{ item.Port }}</div>
        </div>
        <div
          class="item acea-row row-between"
          v-if="item.invoicing && item.paymentType == 1"
        >
          <div>开票服务费：</div>
          <div class="conter">{{ item.invoicing }}元</div>
        </div>
        <div
          class="item acea-row row-between"
          v-if="
            (item.TicketType == 0 || item.TicketType == 2) &&
              item.paymentType == 1
          "
        >
          <div>增值税专票税点：</div>
          <div class="conter sheWidth">{{ item.specialTaxPoints }}元</div>
        </div>
        <div
          class="item acea-row row-between"
          v-if="
            (item.TicketType == 0 || item.TicketType == 1) &&
              item.paymentType == 1
          "
        >
          <div>服务费发票税点：</div>
          <div class="conter sheWidth">{{ item.serviceInvoice }}元</div>
        </div>
        <div class="item acea-row row-between">
          <div>保险费：</div>
          <div class="conter">{{ item.insurance }}元</div>
        </div>
        <div class="item acea-row row-between">
          <div>海关增值税：</div>
          <div class="conter">{{ item.addedInvoice }}元</div>
        </div>
        <div class="item acea-row row-between">
          <div>折合药品单价：</div>
          <div class="conter sheWidth">{{ item.finallySimplePrice }}元</div>
        </div>
        <div class="item acea-row row-between">
          <div>当前药品总计：</div>
          <div class="conter sheWidth">{{ item.moneySum }}元</div>
        </div>
        <div class="quote-project">
          <p class="title">报价单word文档链接:</p>
          <p class="inviteCode" id="inviteCode">
            {{ item.wordLink }}
          </p>
          <div class="btn-position">
            <el-button
              class="copy-link"
              type="primary"
              size="mini"
              data-clipboard-target="#inviteCode"
              >点击复制下载链接</el-button
            >
          </div>
        </div>
        <div class="quote-project">
          <p class="title">合同word文档链接:</p>
          <p class="inviteCode" id="inviteCode1">
            {{ item.contractLink }}
          </p>
          <div class="btn-position">
            <el-button
              class="copy-link"
              type="primary"
              size="mini"
              data-clipboard-target="#inviteCode1"
              >点击复制下载链接</el-button
            >
          </div>
        </div>
      </div>
    </template>
    -->
    <!--
    <div class="make-payment" v-if="orderInfo.pay_type == 'offline'">
      <div class="title">收款银行账号</div>
      <div class="item-box">
        <div>INDUSTRIAL AND COMMERCIAL BANK OF CHINA (MACAU) LIMITED</div>
        <div>银行名称: 中国工商银行(澳门)有限公司</div>
      </div>
      <div class="item-box">
        <div>SWITF CODE : ICBKMOMX</div>
        <div>SWITF代码: ICBKMOMX</div>
      </div>
      <div class="item-box">
        <div>BANK ADDRESS: 18/F,MACAU LANDMARK,555 AV.DA AMIZADE ,MACAU</div>
        <div>银行地址: 澳门友谊大道555号澳门地标18楼</div>
      </div>
      <div class="item-box">
        <div>ACCOUNT NAME: WUZHOU DRUG INTERNATIONAL TRADING LIMITED</div>
        <div>账户名称: 五洲药物国际贸易有限公司</div>
      </div>
      <div class="item-box">
        <div>CCOUNT NO: 0119100600004306067</div>
        <div>账号: 0119100600004306067</div>
      </div>
    </div>
    -->

    <div class="goodCall" @click="toKefu">
      <span class="iconfont icon-kefu"></span><span>联系客服</span>
    </div>

    <div class="wrapper">
      <div class="item acea-row row-between">
        <div>訂單編號：</div>
        <div class="conter acea-row row-middle row-right">
          {{ orderInfo.order_id
          }}<span
            class="copy copy-data"
            :data-clipboard-text="orderInfo.order_id"
            >複製</span
          >
        </div>
      </div>
      <div class="item acea-row row-between">
        <div>下單時間：</div>
        <div class="conter">
          {{ orderInfo.add_time_y + " " + orderInfo.add_time_h }}
        </div>
      </div>
      <div class="item acea-row row-between">
        <div>訂單類型：</div>
        <div class="conter">
          {{ orderTypeName }}
        </div>
      </div>
      <div class="item acea-row row-between">
        <div>支付狀態：</div>
        <div class="conter">{{ orderInfo.paid ? "已支付" : "未支付" }}</div>
      </div>
      <div class="item acea-row row-between">
        <div>支付方式：</div>
        <div class="conter">{{ orderInfo._status._payType }}</div>
      </div>
      <div class="item acea-row row-between" v-if="orderInfo.mark">
        <div>買家留言：</div>
        <div class="conter">{{ orderInfo.mark }}</div>
      </div>
    </div>

    <div v-if="orderInfo.status != 0">
      <div class="wrapper" v-if="orderInfo.delivery_type === 'express'">
        <div class="item acea-row row-between">
          <div>快遞公司：</div>
          <div class="conter">{{ orderInfo.delivery_name || "" }}</div>
        </div>
        <div class="item acea-row row-between">
          <div>快遞號：</div>
          <div class="conter">{{ orderInfo.delivery_id || "" }}</div>
        </div>
        <div class="item acea-row row-between">
          <div>快遞重量(KG)：</div>
          <div class="conter">
            {{ orderInfo.express.totalExpressWeight || 0 }}
          </div>
        </div>
        <div class="item acea-row row-between">
          <div>出庫稱重重量(KG)：</div>
          <div class="conter">
            {{ orderInfo.express.totalWeight || 0 }}
          </div>
        </div>
        <div class="item acea-row row-between">
          <div>總體積(CBM)：</div>
          <div class="conter">
            {{ orderInfo.express.totalVol || 0 }}
          </div>
        </div>
        <div class="item acea-row row-between">
          <div>總數量：</div>
          <div class="conter">
            {{ orderInfo.express.totalQty || 0 }}
          </div>
        </div>
        <div class="item acea-row row-between">
          <div>訂單狀態</div>
          <div class="conter">
            {{ orderInfo.express.orderStatus || 0 }}
          </div>
        </div>
        <div class="item acea-row row-between">
          <div>清關單號/提單號</div>
          <div class="conter">
            {{ orderInfo.express.blNo || "" }}
          </div>
        </div>
      </div>

      <div class="wrapper" v-if="orderInfo.delivery_type === 'send'">
        <div class="item acea-row row-between">
          <div>配送方式：</div>
          <div class="conter">送貨</div>
        </div>
        <div class="item acea-row row-between">
          <div>配送人：</div>
          <div class="conter">{{ orderInfo.delivery_name || "" }}</div>
        </div>
        <div class="item acea-row row-between">
          <div>配送電話：</div>
          <div class="conter acea-row row-middle row-right">
            {{ orderInfo.delivery_id || ""
            }}<a :href="'tel:' + orderInfo.delivery_id"
              ><span class="copy">撥打</span></a
            >
          </div>
        </div>
      </div>
    </div>
    <!--     退款订单详情 -->
    <div class="wrapper" v-if="refundOrder">
      <div class="item acea-row row-between">
        <div>收貨人：</div>
        <div class="conter">{{ orderInfo.real_name }}</div>
      </div>
      <div class="item acea-row row-between">
        <div>聯繫電話：</div>
        <div class="conter">{{ orderInfo.user_phone }}</div>
      </div>
      <div class="item acea-row row-between">
        <div>收貨地址：</div>
        <div class="conter">{{ orderInfo.user_address }}</div>
      </div>
    </div>
    <div class="wrapper">
      <div class="item acea-row row-between">
        <div>支付金額：</div>
        <div class="conter">￥{{ orderInfo.total_price }}</div>
      </div>
      <div class="item acea-row row-between" v-if="orderInfo.coupon_price > 0">
        <div>優惠券抵扣：</div>
        <div class="conter">-￥{{ orderInfo.coupon_price }}</div>
      </div>
      <div class="item acea-row row-between" v-if="orderInfo.use_integral > 0">
        <div>積分抵扣：</div>
        <div class="conter">-￥{{ orderInfo.deduction_price }}</div>
      </div>
      <div class="item acea-row row-between" v-if="orderInfo.pay_postage > 0">
        <div>運費：</div>
        <div class="conter">￥{{ orderInfo.pay_postage }}</div>
      </div>
      <div class="item acea-row row-between" v-if="orderInfo.taxes_price > 0">
        <div>稅費：</div>
        <div class="conter">￥{{ orderInfo.taxes_price }}</div>
      </div>
      <div class="item acea-row row-between">
        <div>操作手续费：</div>
        <div class="conter">￥{{ orderInfo.extra_price }}</div>
      </div>
      <div class="actualPay acea-row row-right">
        實付款：<span class="money font-color-red"
          >￥{{ orderInfo.pay_price }}</span
        >
      </div>
    </div>
    <div style="height: 1.2rem" v-if="!refundOrder && offlineStatus"></div>
    <div
      class="footer acea-row row-right row-middle"
      v-if="!refundOrder && offlineStatus"
    >
      <template v-if="status.type === 0">
        <div class="bnt cancel" @click="cancelOrder">取消訂單</div>
        <div
          class="bnt bg-color-red"
          @click="tellMessage"
          v-if="orderInfo.isAgree === 0"
        >
          審核中
        </div>
        <div
          class="bnt bg-color-red"
          @click="doPay"
          v-else-if="orderInfo.isAgree === 1"
        >
          立即付款
        </div>
        <div class="bnt bg-color-red" @click="showReason = true" v-else>
          重新提交
        </div>
      </template>
      <template v-if="status.type === 1">
        <div
          class="bnt cancel"
          @click="$router.push({ path: '/order/refund/' + orderInfo.order_id })"
        >
          申請退款
        </div>
      </template>
      <template v-if="status.type === 2">
        <div
          v-if="orderInfo.paid === 1 && orderInfo.refund_status === 0"
          class="bnt cancel"
          @click="$router.push({ path: '/order/refund/' + orderInfo.order_id })"
        >
          申請退款
        </div>
        <div
          class="bnt default"
          v-if="orderInfo.delivery_type === 'express'"
          @click="
            $router.push({ path: '/order/logistics/' + orderInfo.order_id })
          "
        >
          查看物流
        </div>
        <div class="bnt bg-color-red" @click="takeOrder">確認收貨</div>
      </template>
      <template
        v-if="status.type === 3 && orderInfo.delivery_type === 'express'"
      >
        <div
          v-if="orderInfo.paid === 1 && orderInfo.refund_status === 0"
          class="bnt cancel"
          @click="$router.push({ path: '/order/refund/' + orderInfo.order_id })"
        >
          申請退款
        </div>
        <div
          v-if="orderInfo.delivery_type === 'express'"
          class="bnt default"
          @click="
            $router.push({ path: '/order/logistics/' + orderInfo.order_id })
          "
        >
          查看物流
        </div>
      </template>
      <template v-if="status.type === 4">
        <div
          v-if="orderInfo.paid === 1 && orderInfo.refund_status === 0"
          class="bnt cancel"
          @click="$router.push({ path: '/order/refund/' + orderInfo.order_id })"
        >
          申請退款
        </div>
        <div class="bnt cancel" @click="delOrder">刪除訂單</div>
        <div
          v-if="orderInfo.delivery_type === 'express'"
          class="bnt default"
          @click="
            $router.push({ path: '/order/logistics/' + orderInfo.order_id })
          "
        >
          查看物流
        </div>
      </template>
      <template v-if="status.type === 6">
        <div
          v-if="orderInfo.paid === 1 && orderInfo.refund_status === 0"
          class="bnt cancel"
          @click="$router.push({ path: '/order/refund/' + orderInfo.order_id })"
        >
          申請退款
        </div>
        <div
          class="bnt bg-color-red"
          @click="
            $router.push({ path: '/activity/group_rule/' + orderInfo.pink_id })
          "
        >
          查看拼團
        </div>
      </template>
      <!--<div
        class="bnt bg-color-red"
        @click="goOrderConfirm(orderInfo)"
        v-if="
          orderInfo.paid === 1 &&
            orderInfo.refund_status === 0 &&
            orderInfo.status >= 2
        "
      >
        再次購買
      </div>-->
    </div>
    <Payment
      v-model="pay"
      :types="payType"
      @checked="toPay"
      :balance="userInfo.now_money"
    ></Payment>
    <div class="geoPage" v-if="mapShow">
      <iframe
        width="100%"
        height="100%"
        frameborder="0"
        scrolling="no"
        :src="
          'https://apis.map.qq.com/uri/v1/geocoder?coord=' +
            system_store.latitude +
            ',' +
            system_store.longitude +
            '&referer=' +
            mapKey
        "
      >
      </iframe>
    </div>
    <GeneralWindow
      :generalActive="generalActive"
      @closeGeneralWindow="closeGeneralWindow"
      :generalContent="generalContent"
    ></GeneralWindow>
    <ChangePrescriptionImg
      :order_id="order_id"
      :showReason="showReason"
      :reason="reason"
    ></ChangePrescriptionImg>
  </div>
</template>
<style scoped>
.goodCall {
  color: #e93323;
  text-align: center;
  width: 100%;
  height: 0.86rem;
  padding: 0 0.3rem;
  border-bottom: 0.01rem solid #eee;
  font-size: 0.3rem;
  line-height: 0.86rem;
  background: #fff;
}
.iconfont {
  margin-right: 0.15rem;
}
.geoPage {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  z-index: 10000;
}
.order-details .writeOff {
  background-color: #fff;
  margin-top: 0.13rem;
  padding-bottom: 0.3rem;
}
.order-details .writeOff .title {
  font-size: 0.3rem;
  color: #282828;
  height: 0.87rem;
  border-bottom: 1px solid #f0f0f0;
  padding: 0 0.3rem;
  line-height: 0.87rem;
}
.order-details .writeOff .grayBg {
  background-color: #f2f5f7;
  width: 5.9rem;
  height: 3.84rem;
  border-radius: 0.2rem 0.2rem 0 0;
  margin: 0.5rem auto 0 auto;
  padding-top: 0.55rem;
}
.order-details .writeOff .grayBg .pictrue {
  width: 2.9rem;
  height: 2.9rem;
  margin: 0 auto;
}
.order-details .writeOff .grayBg .pictrue img {
  width: 100%;
  height: 100%;
  display: block;
}
.order-details .writeOff .gear {
  width: 5.9rem;
  height: 0.3rem;
  margin: 0 auto;
}
.order-details .writeOff .gear img {
  width: 100%;
  height: 100%;
  display: block;
}
.order-details .writeOff .num {
  background-color: #f0c34c;
  width: 5.9rem;
  height: 0.84rem;
  color: #282828;
  font-size: 0.48rem;
  margin: 0 auto;
  border-radius: 0 0 0.2rem 0.2rem;
  text-align: center;
  padding-top: 0.04rem;
}
.order-details .writeOff .rules {
  margin: 0.46rem 0.3rem 0 0.3rem;
  border-top: 0.01rem solid #f0f0f0;
  padding-top: 0.1rem;
}
.order-details .writeOff .rules .item {
  margin-top: 0.15rem;
}
.order-details .writeOff .rules .item .rulesTitle {
  font-size: 0.28rem;
  color: #282828;
}
.order-details .writeOff .rules .item .rulesTitle .iconfont {
  font-size: 0.3rem;
  color: #333;
  margin-right: 0.08rem;
  margin-top: 0.05rem;
}
.order-details .writeOff .rules .item .info {
  font-size: 0.28rem;
  color: #999;
  margin-top: 0.05rem;
}
.order-details .writeOff .rules .item .info .time {
  margin-left: 0.2rem;
}
.order-details .map {
  height: 0.86rem;
  font-size: 0.3rem;
  color: #282828;
  line-height: 0.86rem;
  border-bottom: 0.01rem solid #f0f0f0;
  margin-top: 0.13rem;
  background-color: #fff;
  padding: 0 0.3rem;
}
.order-details .map .place {
  font-size: 0.26rem;
  width: 1.76rem;
  height: 0.5rem;
  border-radius: 0.25rem;
  line-height: 0.5rem;
  text-align: center;
}
.order-details .map .place .iconfont {
  font-size: 0.27rem;
  height: 0.27rem;
  line-height: 0.27rem;
  margin: 0.02rem 0.03rem 0 0;
}
.order-details .address .name .iconfont {
  font-size: 0.34rem;
  margin-left: 0.1rem;
}
.make-payment {
  border: 1px solid #eee;
  margin-top: 5px;
  background: #fff;
}
.make-payment .title {
  text-align: center;
  font-weight: 550;
  padding: 0.25rem 0;
  background: #dedede;
  color: #444;
}
.make-payment .item-box {
  border-top: 1px solid #eee;
  padding: 10px 5px;
}
.make-payment .item-box > div:last-child {
  font-size: 14px;
  color: #777;
  margin-top: 0.1rem;
}
.qoutePrice {
  font-size: 0.3rem;
  line-height: 40px;
  margin-top: -0.2rem;
  font-weight: 700;
  color: #666;
  text-align: center;
  border-bottom: 1px dashed;
  margin-bottom: 0.2rem;
}
.pre .pre-title {
  height: 0.6rem;
  font-size: 0.3rem;
  color: #282828;
  line-height: 0.6rem;
}
.pre .pre-title span {
  font-size: 0.26rem;
  color: #868686;
}
.pre /deep/ .el-image-viewer__close {
  color: #fff;
  z-index: 8888;
}
.demo-image__preview {
  overflow-x: auto;
  overflow-y: hidden;
  white-space: nowrap;
}
.demo-image__preview .el-image {
  width: auto;
  height: 100%;
  margin-right: 10px;
}
.order-details .wrapper .item .conter.sheWidth {
  width: 4.5rem;
}
.quote-project {
  background: #fff;
  margin: 5px 0;
  line-height: 22px;
  border-top: 1px dashed #eee;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 0 5px;
}
.quote-project .inviteCode {
  opacity: 0;
  position: absolute;
  z-index: -1;
  word-break: break-all;
}
.quote-project .btn-position {
  text-align: right;
}
</style>
<script>
import OrderGoods from "@components/moblie/OrderGoods";
import ChangePrescriptionImg from "@components/moblie/ChangePrescriptionImg";
import {
  orderDetail,
  orderAgain,
  orderQuestionnaire,
  checkRepurchase2
} from "@api/order"; //导入复购信息查询接口checkRepurchase
import ClipboardJS from "clipboard";
import Payment from "@components/moblie/Payment";
import { isWeixin } from "@utils";
import { mapGetters } from "vuex";
import {
  cancelOrderHandle,
  takeOrderHandle,
  delOrderHandle,
  payOrderHandle
} from "@libs/order";
import { wechatEvevt } from "@libs/wechat";
import GeneralWindow from "@components/moblie/GeneralWindow";
const NAME = "OrderDetails";
export default {
  name: NAME,
  components: {
    OrderGoods,
    Payment,
    GeneralWindow,
    ChangePrescriptionImg
  },
  props: {},
  data: function() {
    return {
      Afterpurchase: {}, //复购接收
      offlinePayStatus: 2,
      orderTypeName: "普通订单",
      orderTypeNameStatus: true,
      offlineStatus: true,
      id: this.$route.params.id,
      orderInfo: {
        _status: {}
      },
      status: {},
      pay: false,
      payType: isWeixin() ? ["weixin", "alipay"] : ["yue", "alipay"],
      from: isWeixin() ? "weixin" : "weixinh5",
      system_store: {},
      mapKay: "",
      mapShow: false,
      generalActive: false,
      generalContent: {
        promoterNum: "",
        title: ""
      },
      srcList: [],
      productPriceList: [],
      showReason: false,
      reason: "",
      order_id: "",
      isQuestionnaire: false,
      isUpdate: false
    };
  },
  computed: {
    refundOrder() {
      return this.orderInfo.refund_status > 0;
    },
    ...mapGetters(["userInfo"])
  },
  watch: {
    $route(n) {
      if (n.name === NAME && this.id !== n.params.id) {
        this.id = n.params.id;
        this.getDetail();
      }
    }
  },
  inject: ["app"],
  mounted: function() {
    this.checkRepurchase(); //调用复购查询的接口
    this.getIsQuestionnaire();
    console.log("mounted");
    this.getDetail();
    this.$nextTick(function() {
      let copybtn = document.getElementsByClassName("copy-data");
      const clipboard = new ClipboardJS(copybtn);
      clipboard.on("success", () => {
        this.$dialog.success("复制成功");
      });
    });
  },
  methods: {
    //查询复购
    checkRepurchase() {
      checkRepurchase2().then(res => {
        this.Afterpurchase = res;
        console.log(res, this.Afterpurchase, "查询》》》》》");
      });
    },
    //获取isQuestionnaire值
    getIsQuestionnaire() {
      console.log(this.$route);
      if (this.$route.query.isQuestionnaire) {
        let { isQuestionnaire } = this.$route.query;
        this.isQuestionnaire = isQuestionnaire;
      } else {
        //从外部链接获取
        let url = window.location.href;
        let dz_url = url.split("#")[0];
        let cs = dz_url.split("?")[0];
        let cs_arr = cs.split("&");
        let cs_obj = {};
        for (let i = 0; i < cs_arr.length; i++) {
          cs_obj[(cs_arr[i].split("=")[0] = cs_arr[i].split("=")[1])];
        }
        this.isQuestionnaire = cs_obj.isQuestionnaire;
      }
      console.log(this.isQuestionnaire);
    },
    //判断isQuestionnaire
    checkIsQuestionnaire() {
      console.log("checkIsQuestionnaire");
      let cartList = [];
      this.orderInfo.cartInfo.forEach(item => {
        cartList.push(item.productInfo.id + "");
      });
      console.log(this.isQuestionnaire);
      this.isUpdate = true;
      if (
        this.isQuestionnaire
      ) {
        orderQuestionnaire(this.orderInfo.order_id, {
          isQuestionnaire: 1
        }).then(() => {
          this.getDetail();
        });
      }
    },
    //购买
    doPay() {
      console.log("orderInfo");
      console.log(this.orderInfo, "orderInfo");
      console.log(this.userInfo, "userInfo");
      let cartList = [];
      this.orderInfo.cartInfo.forEach(item => {
        cartList.push(item.productInfo.id + "");
      });
      console.log(this.orderInfo)
      //return 1;
      if (
        this.orderInfo.isQuestionnaire === 0 &&
        this.Afterpurchase.data.status === "SUCCESS"
      ) {
        window.location.href = `https://h5.unoeclinic.com/v2/#/article/wzQuestionnaire?order_id=${this.orderInfo.order_id}&type=wechat&user_id=${this.userInfo.uid}`;
        return;
      }
      this.pay = true;
    },
    // 再次购买
    goOrderConfirm(e) {
      orderAgain(e.order_id)
        .then(res => {
          this.$router.push({
            path: "/order/submit/" + res.data.cateId
          });
        })
        .catch(res => {
          this.$dialog.error(res.msg);
        });
    },
    closeGeneralWindow(msg) {
      this.generalActive = msg;
      this.getDetail();
    },
    toKefu() {
      window.location.href =
         "https://work.weixin.qq.com/kfid/kfc17fdc05b8b6141ec";
      // window.location.href =
      //   "https://wpa1.qq.com/kHYHvUz1?_type=wpa&qidian=true";
      //this.$router.push("/customer/list");
    },
    showChang: function() {
      if (isWeixin()) {
        let config = {
          latitude: parseFloat(this.system_store.latitude),
          longitude: parseFloat(this.system_store.longitude),
          name: this.system_store.name,
          address: this.system_store._detailed_address
        };
        wechatEvevt("openLocation", config)
          .then(res => {
            console.log(res);
          })
          .catch(res => {
            if (res.is_ready) {
              res.wx.openLocation(config);
            }
          });
      } else {
        if (!this.mapKey)
          return this.$dialog.error(
            "暂无法使用查看地图，请配置您的腾讯地图key"
          );
        this.mapShow = true;
      }
    },
    goBack() {
      const history = this.app.history,
        last = history[history.length - 1] || {};
      if (last.name === "MyOrder") return this.$router.go(-1);
      else return this.$router.replace({ path: "/order/list/" });
    },
    cancelOrder() {
      cancelOrderHandle(this.orderInfo.order_id)
        .then(() => {
          setTimeout(() => this.goBack(), 300);
        })
        .catch(() => {
          this.getDetail();
        });
    },
    takeOrder() {
      takeOrderHandle(this.orderInfo.order_id)
        .then(res => {
          if (
            (res.data.gain_integral != "0.00" &&
              res.data.gain_coupon != "0.00") ||
            (res.data.gain_integral > 0 && res.data.gain_coupon > 0)
          ) {
            this.generalActive = true;
            this.generalContent = {
              promoterNum: `恭喜您获得${res.data.gain_coupon}元优惠券以及${res.data.gain_integral}积分，购买商品时可抵现哦～`,
              title: "恭喜您获得优惠礼包"
            };
            return;
          } else if (
            res.data.gain_integral != "0.00" ||
            res.data.gain_integral > 0
          ) {
            this.generalActive = true;
            this.generalContent = {
              promoterNum: `恭喜您获得${res.data.gain_integral}积分，购买商品时可抵现哦～`,
              title: "赠送积分"
            };
            return;
          } else if (
            res.data.gain_coupon != "0.00" ||
            res.data.gain_coupon > 0
          ) {
            this.generalActive = true;
            this.generalContent = {
              promoterNum: `恭喜您获得${res.data.gain_coupon}元优惠券，购买商品时可抵现哦～`,
              title: "恭喜您获得优惠券"
            };
            return;
          } else {
            this.$dialog.success("收货成功");
          }
          this.getDetail();
        })
        .catch(res => {
          this.$dialog.error(res.msg);
        });
    },
    delOrder() {
      delOrderHandle(this.orderInfo.order_id).then(() => {
        setTimeout(() => this.goBack(), 300);
      });
    },
    setOfflinePayStatus: function(status) {
      var that = this;
      that.offlinePayStatus = status;
      if (status === 1 && that.orderTypeNameStatus === true) {
        that.payType.push("offline");
      }
    },
    getOrderStatus: function() {
      let orderInfo = this.orderInfo || {},
        _status = orderInfo._status || { _type: 0 },
        status = {};
      let type = parseInt(_status._type),
        delivery_type = orderInfo.delivery_type,
        seckill_id = orderInfo.seckill_id ? parseInt(orderInfo.seckill_id) : 0,
        bargain_id = orderInfo.bargain_id ? parseInt(orderInfo.bargain_id) : 0,
        combination_id = orderInfo.combination_id
          ? parseInt(orderInfo.combination_id)
          : 0;
      status = {
        type: type,
        class_status: 0
      };
      if (type === 1 && combination_id > 0) {
        status.type = 6;
        status.class_status = 1;
      } //查看拼团
      if (type === 2 && delivery_type === "express") status.class_status = 2; //查看物流
      if (type === 2) status.class_status = 3; //确认收货
      if (type === 4 || type === 0) status.class_status = 4; //删除订单
      if (
        !seckill_id &&
        !bargain_id &&
        !combination_id &&
        (type === 3 || type === 4)
      )
        status.class_status = 5; //再次购买
      if (type == 9) {
        //线下付款
        status.class_status = 0;
        this.offlineStatus = false;
      }
      this.status = status;
    },
    getDetail() {
      console.log("getDetail");
      const id = this.id;
      if (!id) return this.$dialog.error("订单不存在");
      orderDetail(id)
        .then(res => {
          this.orderInfo = res.data;
          this.productPriceList = res.data.productPriceList;
          this.srcList = res.data.prescription_images; // 获取处方药 图片
          this.reason = res.data.remark; // 重新提交修改处方图片的参数
          this.order_id = res.data.order_id; // 重新提交修改处方图片的参数
          this.getOrderStatus();
          if (this.orderInfo.combination_id > 0) {
            this.orderTypeName = "拼团订单";
            this.orderTypeNameStatus = false;
          } else if (this.orderInfo.bargain_id > 0) {
            this.orderTypeName = "砍价订单";
            this.orderTypeNameStatus = false;
          } else if (this.orderInfo.seckill_id > 0) {
            this.orderTypeName = "秒杀订单";
            this.orderTypeNameStatus = false;
          }
          this.system_store = res.data.system_store || {};
          this.mapKey = res.data.mapKey;
          this.setOfflinePayStatus(this.orderInfo.offlinePayStatus);
          if (!this.isUpdate) {
            this.checkIsQuestionnaire();
          }
          this.$nextTick(function() {
            let copybtn = document.getElementsByClassName("copy-data");
            const clipboard = new ClipboardJS(copybtn);
            clipboard.on("success", () => {
              this.$dialog.success("复制成功");
            });
          });
        })
        .catch(err => {
          this.$dialog.error(err.msg);
          this.$router.go(-1);
        });
    },
    async toPay(type) {
      var that = this;
      console.log(type);
      await payOrderHandle(this.orderInfo.order_id, type, that.from)
        .then(res => {
          console.log(res);
        })
        .catch(res => {
          if (res.status === "WECHAT_H5_PAY")
            that.$router.push({
              path: "/order/status/" + that.orderInfo.order_id + "/0"
            });
        });
      that.getDetail();
    }
  }
};
</script>
